// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
export const paths: string[] = [
  'M3.5 3H12.5C13.6 3 14.5 3.9 14.5 5V11C14.5 12.1 13.6 13 12.5 13H3.5C2.4 13 1.5 12.1 1.5 11V5C1.5 3.9 2.4 3 3.5 3Z',
  'M1.5 6.6H14.5',
];
